module.exports = __webpack_public_path__ + "img/logo.5756f54d.png";